export default "__VITE_ASSET__BVAo2p1$__"